import { defaultLanguage } from '../appConfig';

const baseTest = window.location.pathname.match(/(.*\/)/);
const base = baseTest ? baseTest[1] : '/';
const config = await fetch(`${base}config.json`).then(r => r.ok ? r.json() : null).catch(e => console.info(e)) || null;

// Set the desired locale globally
export class Locale {
    static get locale(): string {
        return localStorage.getItem('language') || config?.defaultLocale || defaultLanguage
    }
}

export default Locale;
